import * as Tone from 'tone';

// Per-channel insert compressor. Useful for:
//   - taming kick / snare transients
//   - gluing a bus together at a soft ratio
//   - pumping ducked rhythm parts when sidechain isn't available yet

export default {
    id: 'compressor',
    name: 'Comp',
    color: '#a37cdb',
    create() {
        const node = new Tone.Compressor({
            threshold: -18, ratio: 4, attack: 0.005, release: 0.12, knee: 6,
        });
        return {
            node,
            params: [
                { label: 'Thresh', unit: 'dB', min: -60, max: 0, step: 0.5,
                  get: () => node.threshold.value, set: v => { node.threshold.value = v; } },
                { label: 'Ratio',  unit: ':1', min: 1, max: 20, step: 0.5,
                  get: () => node.ratio.value, set: v => { node.ratio.value = v; } },
                { label: 'Attack', unit: 'ms', min: 0.5, max: 100, step: 0.5,
                  get: () => node.attack.value * 1000, set: v => { node.attack.value = v / 1000; } },
            ],
            dispose() { node.dispose(); },
        };
    },
};
